/**
 * Shop group configuration for SwiftSale Manager.
 * Maps URL query parameter keys (?shop=<groupKey>) to lists of branch options.
 */

export const DEFAULT_GROUP_KEY = 'default';

export const SHOP_GROUPS = {
  // Default / fallback group (standard branches)
  default: [
    { label: 'Demo Shop (demo_pos)', value: 'demo_pos' },
  ],

  // Alias for amptess group (?shop=amptess)
  amptess: [
    { label: 'Amptess Mart - Ohwim', value: 'amptess_mart_ohwim' },
    { label: 'Amptess Pharmacy - Ohwim', value: 'amptess_pharm_ohwim' },
    { label: 'Amptess Pharmacy - Ashtown', value: 'amptess_pharm_ashtown' },
    { label: 'Amptess Pharmacy - Breman', value: 'amptess_pharm_breman' },
    { label: 'Amptess Pharmacy - Pantang', value: 'amptess_pharm_pantang' },
  ],

  // Halifat (?shop=halifat)
  halifat: [
    { label: 'Halifat Pharmacy - Suame', value: 'halifat_pharm_suame' },
  ],

};

const PLACEHOLDER_OPTION = { label: 'Select Branch/Shop', value: '' };

/**
 * Retrieves the list of shop options for a given group key.
 * Falls back to the default group if key is invalid or not found.
 * 
 * @param {string} [groupKey] - The group identifier from query param or storage.
 * @returns {Array<{label: string, value: string}>} Dropdown options with placeholder.
 */
export const getShopsForGroup = (groupKey) => {
  const normalizedKey = (groupKey || '').trim().toLowerCase();
  const shops = SHOP_GROUPS[normalizedKey] || SHOP_GROUPS[DEFAULT_GROUP_KEY] || [];
  return [PLACEHOLDER_OPTION, ...shops];
};

/**
 * Checks if a group key exists in configuration.
 * 
 * @param {string} groupKey
 * @returns {boolean}
 */
export const isValidGroup = (groupKey) => {
  if (!groupKey) return false;
  const normalizedKey = groupKey.trim().toLowerCase();
  return Boolean(SHOP_GROUPS[normalizedKey]);
};

/**
 * Resolves a shop code to its user-friendly display name.
 * 
 * @param {string} shopCode
 * @returns {string}
 */
export const getShopNameByCode = (shopCode) => {
  if (!shopCode) return 'No Shop Selected';

  for (const group of Object.values(SHOP_GROUPS)) {
    const found = group.find((shop) => shop.value === shopCode);
    if (found) {
      return found.label.replace(/\s*\([^)]*\)$/, '') || found.label;
    }
  }

  return shopCode
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
